<!--
/**
 * OrangeHRM Telegram configuration page
 */
 -->

<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        Telegram Configuration
      </oxd-text>
      <oxd-divider />

      <oxd-form :loading="isLoading" @submitValid="onSave">
        <oxd-form-row>
          <oxd-grid :cols="2" class="orangehrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.botToken"
                label="Bot Token"
                required
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="form.botUsername"
                label="Bot Username"
                required
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>

        <oxd-divider />
        <oxd-form-row>
          <oxd-input-field
            v-model="autoFetch"
            type="checkbox"
            value="true"
            :option-label="autoFetchLabel"
          />
          <oxd-text tag="p">
            For always-on auto reply on the server, run
            <strong>start-telegram-poller.bat</strong> and keep that window
            open.
          </oxd-text>
          <oxd-text v-if="autoFetch" tag="p">
            Auto-fetch status: {{ lastPollStatus }}
          </oxd-text>
        </oxd-form-row>
        <oxd-divider />

        <oxd-form-actions>
          <oxd-button
            display-type="secondary"
            label="Fetch Messages Now"
            :disabled="isLoading"
            @click="pollNow"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';

export default {
  name: 'TelegramConfig',
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      'api/v2/telegram/config',
    );
    const pollHttp = new APIService(
      window.appGlobal.baseUrl,
      'api/v2/telegram/poll',
    );
    return {http, pollHttp};
  },
  data() {
    return {
      isLoading: false,
      autoFetch: [],
      pollTimer: null,
      lastPollStatus: 'waiting...',
      form: {
        botToken: '',
        botUsername: 'REDIM_HRM_BOT',
      },
    };
  },
  computed: {
    autoFetchLabel() {
      return 'Auto fetch while this page is open (every 3 seconds)';
    },
  },
  watch: {
    autoFetch: {
      handler(val) {
        const on = Array.isArray(val) ? val.includes('true') : !!val;
        if (on) {
          this.startAutoFetch();
        } else {
          this.stopAutoFetch();
        }
      },
      deep: true,
    },
  },
  created() {
    this.load();
  },
  beforeUnmount() {
    this.stopAutoFetch();
  },
  methods: {
    load() {
      this.isLoading = true;
      this.http
        .request({method: 'GET'})
        .then((response) => {
          const data = response.data?.data || {};
          this.form = {
            botToken: data.botToken || '',
            botUsername: data.botUsername || 'REDIM_HRM_BOT',
          };
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onSave() {
      this.isLoading = true;
      this.http
        .request({
          method: 'PUT',
          data: this.form,
        })
        .then(() => {
          this.$toast.saveSuccess();
          this.load();
        })
        .catch(() => {
          this.$toast.error({
            title: 'Error',
            message: 'Failed to save Telegram configuration',
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    startAutoFetch() {
      this.stopAutoFetch();
      this.lastPollStatus = 'running...';
      this.pollQuiet();
      this.pollTimer = setInterval(() => this.pollQuiet(), 3000);
    },
    stopAutoFetch() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    pollQuiet() {
      this.pollHttp
        .create({})
        .then((response) => {
          const data = response.data?.data || {};
          if (data.error) {
            this.lastPollStatus = 'error: ' + data.error;
            return;
          }
          const processed = data.processed || 0;
          this.lastPollStatus =
            processed > 0
              ? `processed ${processed} message(s) at ${new Date().toLocaleTimeString()}`
              : `listening... (${new Date().toLocaleTimeString()})`;
        })
        .catch(() => {
          this.lastPollStatus = 'poll failed';
        });
    },
    pollNow() {
      this.isLoading = true;
      this.pollHttp
        .create({})
        .then((response) => {
          const data = response.data?.data || {};
          if (data.error) {
            this.$toast.error({
              title: 'Telegram Error',
              message: data.error + (data.hint ? ' ' + data.hint : ''),
            });
            return;
          }
          const received = data.received || 0;
          const processed = data.processed || 0;
          if (processed === 0) {
            this.$toast.error({
              title: 'No messages fetched',
              message:
                data.hint ||
                'Generate a NEW link, send /start CODE, then fetch again.',
            });
            return;
          }
          this.$toast.success({
            title: 'Telegram poll OK',
            message: `Bot @${
              data.bot || '-'
            } received ${received}, processed ${processed}. Check Telegram.`,
          });
        })
        .catch((error) => {
          const msg =
            error?.response?.data?.error?.message ||
            'Failed to poll Telegram updates';
          this.$toast.error({
            title: 'Error',
            message: msg,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
